<template lang="pug">
  section.infosvg
    h2(v-if="block.title" v-html="block.title")
    h3(v-if="block.undertitle" v-html="block.undertitle")
    .svg(v-if="block.src" v-html="block.src")
    p(v-if="block.description" v-html="block.description")
    h4(v-if="block.source" v-html="block.source")
</template>
<script>
export default {
  props: {
    block: Object
  }
}
</script>
<style lang="scss" scoped>
  .infosvg{
    border: 1px solid darken(white, 60%);
    padding: 2rem;
    max-width: $overwidth;
    margin-left: auto;
    margin-right: auto;
    @media (max-width: 800px){
      padding: 1rem;
    }
    h2,
    h3,
    h4,
    p{
      font-family: 'LaTercera';
      //reset
      .content .block &{
        max-width: none;
      }
    }
    h2{
      text-transform: uppercase;
      @include fluid-type(360px,
      1440px,
      22px,
      26px);
      font-weight: bold;
    }
    h3{
      @include fluid-type(360px,
      1440px,
      16px,
      22px);
    }
    h4{
      @include fluid-type(360px,
      1440px,
      14px,
      18px);
      text-align: right;
    }
    p{
      @include fluid-type(360px,
      1440px,
      16px,
      18px);
      text-indent: 0;
    }
    .svg{
      // padding: 2rem 0;
    }
  }
</style>


